export default __webpack_public_path__ + "static/media/expand_more_24px.b3ceb250.svg";